import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    appId: String,
    safariWebId: String,
    userId: String
  }

  connect() {
    if (!this.appIdValue) return

    // OneSignal.init is single-flight per page / Turbo: reconnecting this controller
    // must not queue another deferred callback, or the SDK throws "SDK already initialized".
    if (window._nowPtOneSignalDeferredPushed) return
    window._nowPtOneSignalDeferredPushed = true

    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async (OneSignal) => {
      // Browser native permission check
      const nativePermission = Notification.permission; // 'default', 'granted', or 'denied'
      
      // Show bell only on desktop AND only if they haven't made a choice yet
      const showBell = !isMobile && nativePermission === 'default';

      const config = {
        appId: this.appIdValue,
        notifyButton: {
          enable: showBell,
          position: 'bottom-left',
          size: 'medium',
          displayPredicate: () => {
            // This is a OneSignal built-in way to hide/show the bell
            return Notification.permission === 'default';
          },
          colors: {
            'circle.background': '#2563EB'
          }
        },
        allowLocalhostAsSecureOrigin: true,
      };

      if (this.safariWebIdValue) {
        config.safari_web_id = this.safariWebIdValue;
      } else {
        config.safari_web_id = "web.onesignal.auto.1bb493cc-6f2b-4253-90e1-02d85a4b9e78";
      }

      await OneSignal.init(config);

      // Link user ID so we can target this specific user from Ruby
      if (this.userIdValue) {
        OneSignal.login(this.userIdValue);
      }

      // On mobile, show a one-time slide-down prompt if not already decided
      if (isMobile && nativePermission === 'default') {
        setTimeout(() => {
          OneSignal.Slidedown.showHttpPrompt();
        }, 3000);
      }
    });
  }
}
